import { render, staticRenderFns } from "./DefaultLayout.vue?vue&type=template&id=bc1e8674"
import script from "./DefaultLayout.ts?vue&type=script&lang=ts&external"
export * from "./DefaultLayout.ts?vue&type=script&lang=ts&external"
import style0 from "./DefaultLayout.vue?vue&type=style&index=0&id=bc1e8674&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports